import { ProductTypeModelType } from '@teinor/erp/types/company/product/productType'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import useMeasureDictionary from '../../../../../../../utils/hooks/useMeasureDictionary'
import { getISOCurrencyMain } from '../../../../../../../utils/reducers/getters'

interface ModalCEProductTypeProps extends  ModalEditComponentProps {}

const ModalCEProductType: React.FC<ModalCEProductTypeProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const controlUnitTypes = {
        0: { name: t('units', 'Unidades') },
        1: { name: t('measureU', 'U. Medida') },
        2: { name: t('unitsAndMeasureU', 'Unidades y U. Medida') }
    }
    const { measureItems } = useMeasureDictionary()
    const mainCurrency = getISOCurrencyMain()
    const fields: FormRender<ProductTypeModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'divideTotals',
                    label: t('divideTotalsOrder', 'Dividir totales en pedidos'),
                    component: 'CheckboxMargin',
                },
                {
                    label: t('controlUnitType', 'Control de Unidades de Inventario'),
                    name: 'controlUnitType',
                    component: 'CustomSelect',
                    items: controlUnitTypes,
                    value: allRowData?.controlUnitType
                },
                {
                    name: 'unitMeasure',
                    label: t('unitMeasure', 'Unidad de Medida'),
                    component: 'CustomSelectSectionsSearchbar',
                    items: measureItems,
                    value: allRowData?.unitMeasure
                },
                {
                    label: t('wasteWeight', 'Merma'),
                    name: 'wasteWeight',
                    component: 'InputNumberWithLabelMarginTextRightStateFull',
                    textRight: '%'
                },
                {
                    label: t('price', 'Precio'),
                    name: 'price',
                    component: 'InputPriceStateFull',
                    CurrencyId: mainCurrency,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/product/productType/updateProductType'} translations={{ title: t('editProductType', 'Editar Tipo de producto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/product/productType/createProductType'} translations={{
        title: t('createProductType', 'Crear Tipo de producto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEProductType;